<template>
    <div class="flex flex-col w-full h-full items-center justify-center">
        <h1 class="text-2xl font-bold text-theme-title mb-6">Ooops! 404 - No se encontró la página</h1>
        <h2 class="text-xl text-theme-main mb-2">We come in peace. Bring me to your Leader.</h2>
        <h2 class="text-xl text-theme-main">All your base are belong to us..</h2>
    </div>
</template>

<script>
    export default {}
</script>
